import React, { Component } from "react"

class None extends Component {
  render() {
    return (
      <div>
        No page has been created yet for this section.<br/><br/>Create a page in the '/pages' folder and change the current section's 'require(...).default' in './About/index' to link that section to its new page.<br/><br/>If done correctly, the content of the new page should render here instead of this helper text.
      </div>
    )
  }
}

export default None



// WEBPACK FOOTER //
// ./src/scenes/About/pages/none.js